import { ICostsTag } from "@interfaces/admin/costsTag";
import { ICost } from "@interfaces/admin/сost";
import { authApi } from "@RTKQuery/basic";

const costsAuthApi = authApi.injectEndpoints({
    endpoints: (build) => ({
        getAllCosts: build.query<{
            costs: ICost[],
            count_items: number
        }, {
            page: number,
            end_date?: string,
            start_date?: string,
            tag_id?: number
        }>({
            query: (params) => ({
                url: "costs",
                params: Object.assign(
                    {
                        page: params.page,
                        size: 50
                    },
                    params.start_date ? {
                        start_date: params.start_date
                    } : {},
                    params.end_date ? {
                        end_date: params.end_date
                    } : {},
                    params.tag_id ? {
                        tag_id: params.tag_id
                    } : {},
                )
            }),
            providesTags: ["CostsAdmin"]
        }),
        createCost: build.mutation<boolean, {
            suma: number,
            tag_id: ICostsTag["id"]
        }>({
            query: (body) => ({
                url: "costs",
                method: "POST",
                body
            }),
            invalidatesTags: ["CostsAdmin"]
        }),
    }),
    overrideExisting: false,
})

export const {
    useGetAllCostsQuery,
    useCreateCostMutation
} = costsAuthApi;